// src/components/admin/datosMaestrosListas.js
import GestionLugares from './GestionLugares';
import GestionCarpetas from './GestionCarpetas';
import GestionAbogados from './GestionAbogados';
import GestionFeriados from './GestionFeriados';
import GestionReferencias from './GestionReferencias';
import GestionMotivosRechazo from './GestionMotivosRechazo';
import GestionResultadosAtencion from './GestionResultadosAtencion';
import GestionTiposTurno from './GestionTiposTurno';
import GestionAseguradoras from './GestionAseguradoras';
import GestionLesiones from './GestionLesiones';
import GestionPautasReajuste from './GestionPautasReajuste';
import GestionRegimenesDiferenciales from './GestionRegimenesDiferenciales';
import GestionRegimenesJubilacion from './GestionRegimenesJubilacion';

export const RUTA_DATOS_MAESTROS = '/admin/datos-maestros';

// Listas editables de Datos Maestros, agrupadas por módulo. La `clave` es también el último
// tramo de la URL de su página (/admin/datos-maestros/<clave>). `tono` solo pinta el ícono
// (mismos colores que las tarjetas de acceso de RTI, ART, Reajuste y Jubilación).
// Carpetas y Regímenes de Jubilación son las únicas listas que ve quien tiene solo
// 'datosMaestros.carpetas.ver' (hoy, RECEPCION): Recepción inicia jubilaciones y arma la
// documentación de los regímenes nuevos. El resto sigue exigiendo el permiso general 'datosMaestros.ver'.
export const SECCIONES = [
    {
        clave: 'general',
        titulo: 'Opciones Generales',
        icono: 'bi-grid-fill',
        tono: 'azul',
        listas: [
            { clave: 'lugares', titulo: 'Lugares', descripcion: 'Tribunales, oficinas, consultorios y otras ubicaciones', icono: 'bi-geo-alt-fill', Componente: GestionLugares },
            { clave: 'carpetas', titulo: 'Carpetas', descripcion: 'Carpetas físicas del archivo y su orden', icono: 'bi-archive-fill', Componente: GestionCarpetas, visibleSinAccesoCompleto: true },
            { clave: 'abogados', titulo: 'Abogados', descripcion: 'Abogados del estudio y sus matrículas', icono: 'bi-briefcase-fill', Componente: GestionAbogados },
            { clave: 'feriados', titulo: 'Feriados', descripcion: 'Feriados y días inhábiles judiciales', icono: 'bi-calendar-x', Componente: GestionFeriados },
            { clave: 'referencias', titulo: 'Referencias', descripcion: 'Quién derivó a cada cliente al estudio', icono: 'bi-tag-fill', Componente: GestionReferencias },
            { clave: 'motivos-rechazo', titulo: 'Motivos de Rechazo', descripcion: 'Edite las razones de cierre de atención', icono: 'bi-x-octagon-fill', Componente: GestionMotivosRechazo },
            { clave: 'resultados-atencion', titulo: 'Resultados de la Atención', descripcion: 'Cómo terminó cada atención en Recepción', icono: 'bi-flag-fill', Componente: GestionResultadosAtencion },
            { clave: 'tipos-turno', titulo: 'Tipos de Turno', descripcion: 'A qué vino la persona: prefijo, colores y estadísticas', icono: 'bi-ui-radios-grid', Componente: GestionTiposTurno },
        ],
    },
    {
        clave: 'art',
        titulo: 'Configuraciones ART',
        icono: 'bi-heart-pulse-fill',
        tono: 'ambar',
        listas: [
            { clave: 'aseguradoras', titulo: 'Aseguradoras', descripcion: 'ARTs disponibles para los trámites', icono: 'bi-shield-fill-check', Componente: GestionAseguradoras },
            { clave: 'lesiones', titulo: 'Lesiones', descripcion: 'Catálogo de lesiones para siniestros', icono: 'bi-bandaid-fill', Componente: GestionLesiones },
        ],
    },
    {
        clave: 'reajuste',
        titulo: 'Datos de Reajuste',
        icono: 'bi-graph-up-arrow',
        tono: 'naranja',
        listas: [
            { clave: 'pautas-reajuste', titulo: 'Pautas / Fallos', descripcion: 'Pautas y fallos aplicables al reajuste', icono: 'bi-bank2', Componente: GestionPautasReajuste },
        ],
    },
    {
        clave: 'previsional',
        titulo: 'Datos Previsionales',
        icono: 'bi-hourglass-split',
        tono: 'fucsia',
        listas: [
            { clave: 'regimenes-diferenciales', titulo: 'Regímenes Diferenciales', descripcion: 'Edad y servicios mínimos por régimen', icono: 'bi-hammer', Componente: GestionRegimenesDiferenciales },
            { clave: 'regimenes-jubilacion', titulo: 'Regímenes de Jubilación', descripcion: 'Opciones y documentación del régimen diferencial en el trámite de jubilación', icono: 'bi-person-badge', Componente: GestionRegimenesJubilacion, visibleSinAccesoCompleto: true },
        ],
    },
];

export const rutaDeLista = (clave) => `${RUTA_DATOS_MAESTROS}/${clave}`;

export const listaVisible = (lista, accesoCompleto) => accesoCompleto || Boolean(lista.visibleSinAccesoCompleto);

/** Secciones con solo las listas que el usuario puede ver; las que quedan vacías no se devuelven. */
export const seccionesVisibles = (accesoCompleto) => SECCIONES
    .map((seccion) => ({
        ...seccion,
        listas: seccion.listas.filter((lista) => listaVisible(lista, accesoCompleto)),
    }))
    .filter((seccion) => seccion.listas.length > 0);

/** La lista con esa clave (con el `tono` de su sección), o null si no existe. */
export const buscarLista = (clave) => {
    for (const seccion of SECCIONES) {
        const lista = seccion.listas.find((l) => l.clave === clave);
        if (lista) {
            return { ...lista, tono: seccion.tono, seccion: seccion.titulo };
        }
    }
    return null;
};
